import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-working-schedule',
  templateUrl: './working-schedule.component.html',
  styleUrls: ['./working-schedule.component.css']
})
export class WorkingScheduleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
